<template>
  <v-container grid-list-md>
    <v-dialog v-model="dialog" persistent>
      <v-card>
        <v-card-text>
          <v-flex xs12 sm6>
            <v-text-field
              v-model="password"
              :append-icon="showPassword ? 'visibility' : 'visibility_off'"
              :type="showPassword ? 'text' : 'password'"
              label="パスワード"
              hint="8文字以上15文字以下に設定してください"
              counter
              @click:append="showPassword = !showPassword"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              v-model="confirm_password"
              :append-icon="showPassword ? 'visibility' : 'visibility_off'"
              :type="showPassword ? 'text' : 'password'"
              label="パスワード"
              hint="8文字以上15文字以下に設定してください"
              counter
              @click:append="showPassword = !showPassword"
            ></v-text-field>
            <v-flex md6 v-for="(error, i) in errors" :key="i">
              <v-alert :value="true" color="error" outline class="multi-line">{{
                error.message
              }}</v-alert>
            </v-flex>
            <v-alert :value="success" color="success" outline class="multi-line"
              >パスワードを変更しました。</v-alert
            >
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="updatePassword">変更</v-btn>
          <v-btn @click="dialog = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="pageTitle">個人設定</div>
    <div class="subTitle title">アカウント</div>
    <v-btn
      flat
      :to="{ name: 'home', params: { user_id: $route.params.user_id } }"
      color="primary"
    >
      <v-icon>arrow_back_ios</v-icon>タイムシートに戻る
    </v-btn>
    <v-card>
      <v-card-text>
        <v-layout align-center justify-start row fill-height class="table-row">
          <v-flex md3>社員番号</v-flex>
          <v-flex md9>{{ item.staff_id }}</v-flex>
        </v-layout>
        <v-layout align-center justify-start row fill-height class="table-row">
          <v-flex md3>名前</v-flex>
          <v-flex md9>{{ item.name }}</v-flex>
        </v-layout>
        <v-layout align-center justify-start row fill-height class="table-row">
          <v-flex md3>メールアドレス</v-flex>
          <v-flex md9>{{ item.email }}</v-flex>
        </v-layout>
        <v-layout align-center justify-start row fill-height class="table-row">
          <v-flex md3>パスワード</v-flex>
          <v-flex md9>
            <v-btn
              small
              @click="
                dialog = true;
                success = false;
              "
              >パスワード変更</v-btn
            >
          </v-flex>
        </v-layout>
        <v-layout align-center justify-start row fill-height class="table-row">
          <v-flex md3>チーム</v-flex>
          <v-flex md9>{{ item.team_name }}</v-flex>
        </v-layout>
        <v-layout align-center justify-start row fill-height class="table-row">
          <v-flex md3>ユーザー種別</v-flex>
          <v-flex md9>{{ item.user_type }}</v-flex>
        </v-layout>
      </v-card-text>
    </v-card>

    <div class="subTitle title">タイムカード</div>
    <v-card>
      <v-card-text>
        <v-layout align-center justify-start row fill-height class="table-row">
          <v-flex md2>勤怠種別</v-flex>
          <v-flex md5>{{ item.work_type }}</v-flex>
          <v-flex md3 v-if="item.work_type == '一般'">
            <v-checkbox
              v-model="item.few_work_days"
              :label="`勤務日時少`"
              :disabled="true"
            ></v-checkbox>
          </v-flex>
        </v-layout>
        <v-layout align-center justify-start row fill-height class="table-row">
          <v-flex md3>一日の標準時間</v-flex>
          <v-flex md9>
            <input-time :isBy10Minutes="true" v-model="item.predefined_time" />
          </v-flex>
        </v-layout>
        <v-layout
          v-if="item.work_type == '一般'"
          align-center
          justify-start
          row
          fill-height
          class="table-row"
        >
          <v-flex md3>基本給</v-flex>
          <v-flex md3>
            <v-text-field
              v-model.number="item.base_salary"
              suffix="円"
              min="0"
              type="number"
              required
            />
          </v-flex>
        </v-layout>
        <v-layout
          v-if="item.work_type == '時給' || item.work_type == 'アルバイト'"
          align-center
          justify-start
          row
          fill-height
          class="table-row"
        >
          <v-flex md3>時給</v-flex>
          <v-flex md3>
            <v-text-field
              v-model.number="item.hourly_base_salary"
              suffix="円"
              min="0"
              type="number"
              required
            />
          </v-flex>
        </v-layout>
        <v-radio-group v-model="item.commuting_allowance_type" row>
          <v-radio label="月額" value="月額"></v-radio>
          <v-radio label="日額" value="日額"></v-radio>
        </v-radio-group>
        <v-layout
          v-if="item.commuting_allowance_type != '日額'"
          align-center
          justify-start
          row
          fill-height
          class="table-row"
        >
          <v-flex md3>通勤費</v-flex>
          <v-flex md3>
            <v-text-field
              type="number"
              v-model.number="item.commuting_allowance"
              suffix="円"
            />
          </v-flex>
        </v-layout>
        <v-layout
          v-else
          align-center
          justify-start
          row
          fill-height
          class="table-row"
        >
          <v-flex md3>通常通勤経路</v-flex>
          <v-flex md4>
            <v-text-field v-model="item.daily_commuting_route" />
          </v-flex>
          <v-flex md1>通常通勤費</v-flex>
          <v-flex md2>
            <v-text-field
              type="number"
              v-model.number="item.daily_commuting_allowance"
              suffix="円"
            />
          </v-flex>
        </v-layout>
        <v-layout align-center justify-start row fill-height class="table-row">
          <v-flex md3>健康保険料</v-flex>
          <v-flex md3>
            <v-text-field
              type="number"
              v-model.number="item.kenko_insurance"
              suffix="円"
            />
          </v-flex>
        </v-layout>
        <v-layout align-center justify-start row fill-height class="table-row">
          <v-flex md3>厚生年金保険料</v-flex>
          <v-flex md3>
            <v-text-field
              type="number"
              v-model.number="item.kouseinenkin_insurance"
              suffix="円"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-btn @click.stop="updateItem">更新</v-btn>
      </v-card-actions>
    </v-card>
    <v-btn
      flat
      :to="{ name: 'home', params: { user_id: $route.params.user_id } }"
      color="primary"
    >
      <v-icon>arrow_back_ios</v-icon>タイムシートに戻る
    </v-btn>
  </v-container>
</template>

<script>
import db from "@/components/firebaseInit";
import firebase from "firebase";
import InputTime from "@/components/inputLargeTime";
import { mapMutations, mapGetters, mapActions } from "vuex";

export default {
  components: {
    InputTime,
  },
  props: [],
  data() {
    return {
      item: {},
      dbRef: db.collection("users"),
      valid: false,
      name: "",
      nameRules: [(v) => !!v || "必須事項です"],
      email: "",
      emailRules: [
        (v) => !!v || "必須事項です",
        (v) => /.+@.+/.test(v) || "E-mailの形式ではありません。",
      ],
      date: null,
      dialog: false,
      showPassword: false,
      confirm_password: "",
      password: "",
      errors: [],
      success: false,
    };
  },
  computed: {
    title() {
      return "ユーザー情報" + (this.action == "add" ? " 新規追加" : " 更新");
    },
    ...mapGetters("auth", ["user"]),
  },
  mounted() {
    this.reoload();
  },
  methods: {
    async reoload() {
      try {
        this.changeLoadingState(true);
        const doc = await this.dbRef.doc(this.$route.params.user_id).get();
        if (doc.exists) {
          this.item = Object.assign({}, doc.data());
          this.item.id = doc.id;
        } else {
          console.error("The document doesn't exist");
        }
      } catch (e) {
        console.error(e);
      }
      this.changeLoadingState(false);
    },
    async updateItem() {
      this.changeLoadingState(true);
      try {
        await this.dbRef.doc(this.$route.params.user_id).set(this.item);
      } catch (e) {
        console.error(e);
      }
      this.changeLoadingState(false);
      this.reoload();
    },
    async updatePassword() {
      if (this.validatePassword()) {
        this.changeLoadingState(true);
        try {
          const user = firebase.auth().currentUser;
          await user.updatePassword(this.password);
          this.success = true;
        } catch (error) {
          console.error(error);
          if (error.code == "auth/requires-recent-login") {
            this.errors.push({
              message:
                "変更に失敗しました。ログアウト、ログインしてから再度変更してください。",
            });
          } else {
            this.errors.push({ message: "原因不明のエラーで失敗しました。" });
          }
        } finally {
          this.changeLoadingState(false);
        }
      }
    },
    validatePassword() {
      let result = true;
      this.errors = [];
      if (this.password.length < 8 || this.password.length > 15) {
        result = false;
        this.errors.push({ message: "8文字以上15文字以下に設定してください" });
      }
      if (this.password != this.confirm_password) {
        result = false;
        this.errors.push({
          message: "パスワードと確認用パスワードが一致しません。",
        });
      }
      return result;
    },
    ...mapActions("app", ["changeLoadingState"]),
  },
};
</script>

<style lang="scss" scoped>
div.pageTitle {
  font-size: 20px;
  color: #ff5722;
  font-family: YuGothicM, Roboto, sans-serif;
  font-weight: bold;
  margin: 10px;
}
.table-row {
  border-bottom: solid 1px #e0e0e0;
  height: 48px;
}
.subTitle {
  margin: 10px;
}
</style>


